import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";

import { getProjects } from "../actions/resourceActions";

import ProjectsList from "../components/projects/List";
import {TouchPageHeader, TouchPageHeader_and_content_spaceBetween} from "../AtollonTheme/ReactElements";
import { Button, FontIcon } from "react-md";

const Projects = ({ history, projects, searchBar }) => {
  return (
    <div className="flex-col">
        <TouchPageHeader
            title={"Projekty"}
            debugText={"containers/projects.js"}
            buttons={(

                <div>
                    <Button
                        raised
                        className="btn btn-primary touchButton-1"
                        label="Přidat projekt"
                        onClick={() => history.push("/project-new")}
                    >
                        <FontIcon className="color-white">album</FontIcon>
                    </Button>
                </div>

            )}
        />
        <TouchPageHeader_and_content_spaceBetween heightPx={45}/>

        <ProjectsList history={history} projects={projects} searchBar={searchBar} />
    </div>
  );
};

export default compose(
  connect(({ resource: { projects }, searchBar }) => ({ projects, searchBar }), { getProjects }),
  lifecycle({
    async componentWillMount() {
      const { getProjects } = this.props;

      getProjects();
    }
  })
)(Projects);



// WEBPACK FOOTER //
// ./src/pages/Projects.js